export default __webpack_public_path__ + "static/media/logo-dark.1d6f4328.svg";